/* eslint-disable */

const DEFAULT_CONSTANTS = {
  INVALID_INPUT_MESSAGE: "Input should be a valid number greater than 0.",
  UNLUCKY_MESSAGE:
    "If you think you're a disappointment then maybe you're right because your birthday is not lucky at all!😔",
  LUCKY_MESSAGE: "Woah! Your birthday is lucky!😎🥳 Cheer up!🍺",
  APP_DESCRIPTION:
    "Enter your date of birth and lucky number to know if your birthday is lucky or not.",
  PRIVACY_NOTICE: "🛑Privacy notice: We're not storing any data.🛑",
};

export default DEFAULT_CONSTANTS;
